// extracted by mini-css-extract-plugin
module.exports = {"review_modal":"ReviewModal_review_modal__X8ndm","content":"ReviewModal_content__TKtqy"};